import React from "react";
import Form from "../../home/Apply/Form";
import Squiggle from "../InstantCash/Squiggle";
import Envelope from "./Envelope";
import { APPLY_ANCHOR_ID } from "../InstantCash/anchors";
import { ReactComponent as Feather } from "../../../../assets/landing/patria-feather.svg";
import {
  Wrapper,
  Feather as FeatherSlot,
  Inner,
  Copy,
  CardWrap,
  Sticker,
  Card,
} from "./Hero.styles";

const checks = [
  "60 seconds to check",
  "No hard credit pull",
  "Deposits often in minutes",
];

const pills = ["Bank-level security", "No obligation", "Tribal-owned"];

/**
 * The reference form collects ZIP code and date of birth to look up a mailed
 * offer. The shared lead form has neither field and the /lead/landing endpoint
 * does not accept them, so the real five fields are kept and relabelled where
 * they correspond. Wiring an actual offer lookup is a backend change.
 */
const FORM_PLACEHOLDERS = {
  requestedLoan: "Loan amount",
  reason: "What's it for?",
  ssn: "SSN",
  phoneNumber: "Phone",
  email: "Email",
};

const Check = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 12l4 4L19 6" />
  </svg>
);

const Hero = ({ directMailUrl }: { directMailUrl?: string }) => {
  return (
    <Wrapper className="section-lp3-hero">
      <FeatherSlot aria-hidden="true">
        <Feather />
      </FeatherSlot>

      <Inner>
        <Copy>
          <p className="eyebrow">
            <Envelope />
            You received a letter from us
          </p>

          <h1 className="headline">
            <span className="line">You&apos;re</span>
            <span className="marked">
              <span>Preapproved.</span>
              <Squiggle />
            </span>
          </h1>

          <p className="subhead">
            Your mailed offer of <strong>up to $2,000</strong> is waiting. Check
            your status in about a minute — we&apos;ll look up your offer
            automatically.
          </p>

          <ul className="checks">
            {checks.map((label) => (
              <li className="check" key={label}>
                <span className="check-icon">
                  <Check />
                </span>
                {label}
              </li>
            ))}
          </ul>

          <div className="pills">
            {pills.map((label) => (
              <span className="pill" key={label}>
                {label}
              </span>
            ))}
          </div>
        </Copy>

        <CardWrap id={APPLY_ANCHOR_ID}>
          <Sticker className="sticker-left">Preapproved</Sticker>
          <Sticker className="sticker-right">Up to $2,000</Sticker>

          <Card className="form-wrapper">
            <p className="card-eyebrow">Check your approval status</p>
            <h2 className="card-heading">
              See your offer in <span className="accent">60 seconds</span>.
            </h2>
            <p className="card-note">
              We&apos;ll match you to the offer we mailed you. No hard credit
              pull.
            </p>
            <div className="card-form">
              <Form
                applyButtonLabel="Check my approval status"
                placeholders={FORM_PLACEHOLDERS}
              />
              {directMailUrl ? (
                <p className="mail-note">
                  Didn&apos;t receive a letter?{" "}
                  <a href={directMailUrl} target="_blank" rel="noreferrer">
                    Apply here
                  </a>
                </p>
              ) : null}
            </div>
          </Card>
        </CardWrap>
      </Inner>
    </Wrapper>
  );
};

export default Hero;
